export const email = {
  name: "email" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="m3.4 7.409 7.403 6.299.03.025a1.9 1.9 0 0 0 2.362-.024l8.886-7.522A.9.9 0 0 0 21.5 4.6h-18a1.9 1.9 0 0 0-1.9 1.9v11c0 1.05.85 1.9 1.9 1.9h17a1.9 1.9 0 0 0 1.9-1.9V9.727a.9.9 0 0 0-1.8 0V17.5a.1.1 0 0 1-.1.1h-17a.1.1 0 0 1-.1-.1V7.409ZM19.044 6.4H4.992l6.954 5.918a.1.1 0 0 0 .108 0l6.99-5.918Z" clip-rule="evenodd"/></svg>`,
  keywords: ["email"],
  category: "communication" as const,
};
